var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popup_content"},[_c('v-popuptitle',{attrs:{"message":"치료 이력","imgsrc":"common/ic_agreement.png"}}),_c('div',{staticClass:"popup__con_inner pt30"},[_c('v-table',{attrs:{"data":_vm.table,"cmp":"historyPopup"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }